"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var solana_headless_core_1 = require("@hermis/solana-headless-core");
var useConnection_1 = require("../hooks/useConnection");
/**
 * Provider for Solana connection with dual architecture support
 *
 * This provider creates and manages a Solana connection instance that works
 * with both legacy (@solana/web3.js) and Kit (@solana/kit) architectures.
 *
 * By default, this creates a legacy Connection from @solana/web3.js, which is
 * compatible with all existing code. The connection is typed as DualConnection,
 * meaning it will work seamlessly with:
 * - Legacy transactions (Transaction, VersionedTransaction)
 * - Kit transactions (TransactionMessage)
 * - All dual architecture helper functions
 *
 * To use a Kit Rpc connection instead, you can create a custom connection provider
 * that creates a Kit Rpc instance and passes it through the same context.
 *
 * @example
 * // Standard usage with legacy connection (default)
 * <ConnectionProvider endpoint="https://api.devnet.solana.com" network="devnet">
 *   <YourApp />
 * </ConnectionProvider>
 *
 * @param props ConnectionProviderProps
 * @returns ConnectionProvider component
 */
var ConnectionProvider = function (_a) {
    var children = _a.children, endpoint = _a.endpoint, _b = _a.config, config = _b === void 0 ? { commitment: 'confirmed' } : _b, network = _a.network;
    var connection = (0, react_1.useMemo)(function () {
        return new solana_headless_core_1.Connection(endpoint, config);
    }, [endpoint, config]);
    return ((0, jsx_runtime_1.jsx)(useConnection_1.ConnectionContext.Provider, { value: { connection: connection, network: network }, children: children }));
};
exports.ConnectionProvider = ConnectionProvider;
